var stream = {};
export {
  stream as __exports
};
//# sourceMappingURL=stream.js.map
